import FleetModal, { useAsyncModal } from '@/libs/antd/components/Modal';
import FleetTitle from '@/libs/antd/components/Title';
import { useForm } from '@/libs/antd/form';
import { inputCurrency } from '@/libs/antd/input-number';
import ANTD_DEFAULT_PROPS from '@/libs/antd/props';
import rule from '@/libs/antd/rules';
import {
	useSelectBrand,
	useSelectBrandType,
} from '@/libs/fleet-api/hooks/master-data';
import { MasterData } from '@/libs/fleet-api/services/master-data';
import { Col, Divider, Form, InputNumber, Row, Select } from 'antd';
import { FC } from 'react';

export type BrandModalForm = {
	brandDetailId?: number;
	brandId: MasterData;
	brandTypeId: MasterData;
	unit: number;
	amount: number;
};

export const useBrandModal = () => {
	return useAsyncModal<BrandModalForm, BrandModalForm>();
};

const BrandModal: FC<ReturnType<typeof useBrandModal>> = (props) => {
	const { form, value, fieldName } = useForm<BrandModalForm>();

	const selectBrand = useSelectBrand();
	const selectBrandType = useSelectBrandType(value?.brandId?.id?.toString());

	return (
		<FleetModal
			{...props.modal}
			width={940}
			closable={false}
			buttonPosition="end"
			okText="SAVE"
			cancelText="BACK"
			onOk={async () => {
				const values = await form.validateFields();
				props.close(values);
			}}
			afterOpenChange={(isOpen) => {
				if (!isOpen) {
					form.resetFields();
				} else if (props.data) {
					form.setFieldsValue(props.data);
				}
			}}
		>
			<FleetTitle>Add Brand & Detail Jenis Unit</FleetTitle>
			<Form
				{...ANTD_DEFAULT_PROPS.FORM}
				form={form}
				labelCol={{ span: 6 }}
				wrapperCol={{ span: 18 }}
			>
				<Form.Item
					name={'brandDetailId'}
					noStyle
				/>
				<Row
					gutter={40}
					style={{ marginTop: 20 }}
				>
					<Col span={12}>
						<Form.Item
							label="Brand"
							name={'brandId'}
							getValueFromEvent={(_, option) => option?.data}
							getValueProps={(value) => {
								if (!value) return {};
								return {
									value: {
										value: value.id,
										label: value.value,
									},
								};
							}}
							rules={[rule.required()]}
						>
							<Select
								{...selectBrand}
								onSelect={(value, option) => {
									selectBrand.onSelect!(value, option);
									form.setFieldValue(fieldName('brandTypeId'), null);
								}}
								onClear={() => {
									form.setFieldValue(fieldName('brandTypeId'), null);
								}}
							/>
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label="Type Unit"
							name={'brandTypeId'}
							getValueFromEvent={(_, option) => option?.data}
							getValueProps={(value) => {
								if (!value) return {};
								return {
									value: {
										value: value.id,
										label: value.value,
									},
								};
							}}
							rules={[rule.required()]}
						>
							<Select {...selectBrandType} />
						</Form.Item>
					</Col>
				</Row>
				<Divider />
				<Row gutter={40}>
					<Col span={12}>
						<Form.Item
							label="Jumlah Unit"
							name={'unit'}
							rules={[rule.required()]}
						>
							<InputNumber />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label="Amount"
							name={'amount'}
							rules={[rule.required()]}
						>
							<InputNumber {...inputCurrency} />
						</Form.Item>
					</Col>
				</Row>
			</Form>
		</FleetModal>
	);
};

export default BrandModal;
